export default __webpack_public_path__ + "static/Istio Ingress Gateway-396456d4de0135c0fe63099284a960b2.webp";